import { cn } from "../lib/cn";

export interface StepLadderItem {
  label: string;
}

/**
 * The six-step MTM workflow ladder from the imported design — a numbered progress rail
 * (Intake → Reconciliation → Assessment → MRPs → Interventions → Care Plan → Follow-up maps
 * onto it) that a pharmacist can also click to jump between steps directly. Purely a
 * navigation/progress affordance; it carries no state of its own beyond the active index.
 */
export function StepLadder({
  steps,
  activeIndex,
  onStepClick,
  className,
}: {
  steps: StepLadderItem[];
  activeIndex: number;
  onStepClick?: (index: number) => void;
  className?: string;
}) {
  return (
    <div className={cn("relative flex max-w-4xl justify-between", className)}>
      <div className="absolute start-[13px] end-[13px] top-[13px] h-px bg-charcoal-900/20" />
      {steps.map((step, i) => {
        const n = i + 1;
        const isActive = n === activeIndex;
        const isDone = n < activeIndex;
        return (
          <div key={step.label} className="relative flex w-[110px] flex-col items-center gap-2">
            <button
              type="button"
              onClick={() => onStepClick?.(n)}
              className={cn(
                "flex h-[27px] w-[27px] items-center justify-center rounded-full border text-xs font-semibold transition-transform duration-150",
                isActive && "scale-[1.16] border-transparent bg-charcoal-900 text-background",
                isDone && "border-transparent bg-primary-600 text-background",
                !isActive && !isDone && "border-charcoal-900/25 bg-transparent text-charcoal-500",
              )}
            >
              {n}
            </button>
            <div className={cn("text-center text-[11.5px] leading-tight", isActive ? "text-charcoal-900" : "text-charcoal-500")}>
              {step.label}
            </div>
          </div>
        );
      })}
    </div>
  );
}
